export enum ServiceType {
  IN_GROUND = 'in-ground',
  MAUSOLEUM = 'mausoleum',
}

export const ServiceTypeValue: Record<ServiceType, string> = {
  [ServiceType.IN_GROUND]: 'In-ground',
  [ServiceType.MAUSOLEUM]: 'Mausoleum',
};
